'use strict';

const InfoPresenter = require('../presenters/info');

const BaseView = require('./base');

class InfoView extends BaseView {
  initialize() {
    this.module = 'glive_booking_redesign';
    this.presenter = InfoPresenter;
    this.templateName = 'info';
  }
}

module.exports = InfoView;
